<template>
  <footer class="bg-kintz-primary-1 mt-auto">
    <div class="max-w-7xl mx-auto py-12 px-4 overflow-hidden sm:px-6 lg:px-8">
      <p class="mt-8 text-center text-base text-kintz-primary-2">
        &copy; {{ new Date().getFullYear() }} KintzNow, Inc. All rights reserved.
      </p>
    </div>
  </footer>
</template>
